import { createFileRoute } from "@tanstack/react-router";
import FindAVerifiedSaintProviderEs from "@/pages/es/FindAVerifiedSaintProviderEs";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/find-a-verified-saint-provider`;

export const Route = createFileRoute("/es/find-a-verified-saint-provider")({
  head: () => ({
    meta: [
      { title: "Encuentre un proveedor verificado de SAINT® | Neuro Wellness" },
      {
        name: "description",
        content:
          "Verifique un proveedor autorizado de SAINT® TMS. Vea el listado oficial de Magnus Medical de Neuro Wellness TMS Centers of America en Coral Springs, FL.",
      },
      {
        property: "og:title",
        content: "Encuentre un proveedor verificado de SAINT®",
      },
      {
        property: "og:description",
        content:
          "Neuro Wellness TMS Centers of America es un proveedor verificado de SAINT® en Coral Springs, FL.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "Encuentre un proveedor verificado de SAINT®",
      },
      {
        name: "twitter:description",
        content:
          "Neuro Wellness TMS Centers of America es un proveedor verificado de SAINT® en Coral Springs, FL.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/find-a-verified-saint-provider"),
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <FindAVerifiedSaintProviderEs />;
}
